import { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import useViewport, { Viewport } from "../../hooks/useViewport";

import CarouselButtons from "../carousel-buttons/carousel-buttons";
import LocationListItem from "../location-list-item/location-list-item";

import styles from "./location-slider.module.scss";

const LocationSlide = ({ loc }) => {
  return (

    <LocationListItem
      large
      key={loc.name}
      location={loc}
    />

  );
};

const LocationSlider = ({ locations }) => {
  const device = useViewport();

  const [currentSlide, setCurrentSlide] = useState(0);

  if (device === Viewport.PHONE) {
    return (
      <div className={styles.MobileCarousel}>
        <Carousel
          showArrows={false}
          showStatus={false}
          infiniteLoop={false}
          showIndicators={false}
          autoPlay={false}
          selectedItem={currentSlide}
          swipeScrollTolerance={20}
          preventMovementUntilSwipeScrollTolerance
          onChange={(index) => setCurrentSlide(index)}
        >
          {locations.map(
            (loc) => (
              <LocationSlide key={loc.name} loc={loc} />
            )
          )}
        </Carousel>
        <CarouselButtons
          slides={locations.map((loc, index) => ({
            active: index === currentSlide
          }))}
          onChange={(index) => setCurrentSlide(index)}
        />
      </div>
    );
  }

  return (
    <div className={styles.Scroll}>
      <div className={styles.Posts}>
        {locations.map((loc) => (
          <LocationSlide key={loc.name} loc={loc} />
        ))}
      </div>
    </div>
  );
};

export default LocationSlider;
